import * as types from '../actions/actionTypes';

export const enableGettingStarted = () => {
    return { type: types.GETTING_STARTED_ENABLED_CHANGE_REQUESTED, enable: true };
};

export const dismissGettingStarted = () => {
    return { type: types.GETTING_STARTED_ENABLED_CHANGE_REQUESTED, enable: false };
};


// WEBPACK FOOTER //
// ./src/js/actions/gettingStartedActionCreators.js